module.exports = __webpack_public_path__ + "marriotthomesandvillas-logo.png?1977cc0cfca9af7ed8119f621066a530";